import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';

import { selectSelectedRecordsIds } from '../selectors/records-base.selectors';
import {
  selectSelectedRecordsEditAttributes,
  selectSelectedWorkCalendarsRecordsProjectIds,
} from '../selectors/selectedRecords.selectors';
import { updateRecords } from '../services/updateRecords.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const editRecords = createAsyncThunk(
  'records/editRecords',
  async (_, { rejectWithValue, getState }) => {
    const state = getState();

    const attributesToEdit = selectSelectedRecordsEditAttributes(state);
    const selectedRecordsProjectIds =
      selectSelectedWorkCalendarsRecordsProjectIds(state);

    const projectIds =
      attributesToEdit && attributesToEdit.project
        ? [...selectedRecordsProjectIds, attributesToEdit.project]
        : selectedRecordsProjectIds;
    const selectedRecordsIds = selectSelectedRecordsIds(state);

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const uniqProjectIds = uniq(projectIds);

    try {
      const response = await updateRecords(
        uniqProjectIds,
        selectedRecordsIds,
        attributesToEdit,
        activeEmployerInfo
      );
      return response;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);
